module.exports = __webpack_public_path__ + "img/009-garbage.0cf31964.svg";